import axios from 'axios';
import authService from './authService';
import { environment } from '../environments';
import { installAxiosInFlightDedupe } from './axiosInFlightDedupe';

// יצירת מופע axios עם הגדרות ברירת מחדל
const api = axios.create({
  baseURL: environment.apiUrl, // החלף בכתובת ה-API שלך
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

installAxiosInFlightDedupe(api);

// הוספת interceptor לבקשות
api.interceptors.request.use(
  (config) => {
    // הוספת טוקן אימות לכל בקשה
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// הוספת interceptor לתשובות
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // טיפול בשגיאות באופן גלובלי
    if (error.response) {
      // הבקשה נשלחה והשרת הגיב עם קוד שגיאה
      console.error('Response error:', error.response.data);
      
      // טיפול בשגיאת 401 Unauthorized
      if (error.response.status === 401) {
        console.log('401 Unauthorized detected - redirecting to login', {
          url: error.config?.url,
          method: error.config?.method,
          data: error.config?.data
        });
        // ניתוק המשתמש במקרה של שגיאת אימות
        authService.logout();
        // הפניה לדף התחברות
        window.location.href = '/login';
      }
    } else if (error.request) {
      // הבקשה נשלחה אך לא התקבלה תשובה
      console.error('Request error:', error.request);
    } else {
      // שגיאה בהגדרת הבקשה
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
